<template lang="pug">
.uploadSearch.container
  .title 訂單查詢
  hr.w-100
  p test
  p test
  p test
  ul.nav.nav-tabs
    li.nav-item
      router-link.nav-link.active(aria-current="page" to="/upload") 待上傳訂單
    li.nav-item
      router-link(to="/upload/orderid").nav-link 歷史訂單

  router-view
  router-view(name="orderContent")

</template>

<script>
import searchOrder from '../searchOrder.vue'
import orderContent from '../orderContent.vue'
import uploadFile from '../uploadFile.vue'

export default {
  components: {
    searchOrder,
    orderContent,
    uploadFile
  },
  data () {
    return {
      url: 'https://dev-api.cloudw2p.com/api/v1/pdfwkflow/multiuploads',
      params: {
        ordernumber: 123,
        itemnumber: 25859
      },
      mimeTypes: 'application/pdf',
      maxFileSizeLimit: 40
    }
  },
  methods: {
    whenUpload (msg) {
      console.log(msg)
    },
    uploadCallBack (uploader, file, responseObject) {
      console.log(responseObject)
    },
    errorCallBack (uploader, error) {
      console.log(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 24px;
  font-weight: bold;
  font-family: "Noto Serif TC",serif;
}
.searchBtn{
  flex-shrink: 0;
}

@media(min-width: 640px) {
  .searchBarContent{
    display:flex;
    justify-content:center;
    align-items:center;
    input[type="date"]{
      margin:0 8px;
    }
  }
}
@media(max-width: 641px) {
  .searchBarContent{
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    input[type="date"]{
      margin:0 0 8px;
    }
  }
}

th,td{
  vertical-align: middle;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/upload.vue